export default "/images/project2.jpg?b3ce546a9878996067ad32e50515ecf2";